export enum DashboardLayouts {
  TILE = 'grid',
  LIST = 'list',
  MAP = 'map'
}
